export const projects = [
  {
    id: 'a2a-hackathon',
    title: 'Agent-to-Agent Deal Negotiation',
    subtitle: 'Hackathon Winner · Internal',
    year: '[Year TBD]',
    description:
      'Prototype demonstrating autonomous agent-to-agent negotiation for programmatic ad deals. Built supporting Model Context Protocol (MCP) integrations to broker capabilities between agents.',
    tech: ['Agentic Systems', 'MCP', 'TypeScript'],
    private: true,
  },
  {
    id: 'live-event-adser',
    title: 'Live-Event Ad Server',
    subtitle: 'In progress · Side',
    year: '2026',
    description:
      'Ad server tailored for live-event traffic profiles. Event-driven architecture and micro-batch processing tuned for spike-load scenarios where conventional ad servers degrade.',
    tech: ['Event-Driven', 'Micro-batch', 'Distributed Systems'],
    private: true,
  },
  {
    id: 'outbreaks',
    title: 'Outbreaks',
    subtitle: 'Interactive D3 visualization',
    year: '2021',
    description:
      'Comparative dashboard for COVID-19 alongside historical outbreaks (Spanish flu, SARS, MERS, Ebola). Built with D3 and deployed via GitHub Pages.',
    tech: ['D3.js', 'JavaScript', 'GitHub Pages'],
    href: 'https://vivekvyellanti.github.io/outbreaks/',
  },
];
